import React, { ReactNode, useContext, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import socket from "../config/socket";
import { socketConntected } from "../Data/features/authSlice";
import { RootState } from "../store";

const SocketContext = React.createContext<typeof socket | null>(null);

export function useSocket() {
    return useContext(SocketContext);
}


interface SocketProviderProps {
    children: ReactNode;
}

export function SocketProvider({ children }: SocketProviderProps) {
    const { isLoggedIn, user } = useSelector((state: RootState) => state.auth)
    const dispatch = useDispatch();

    useEffect(() => {
        if (isLoggedIn) {
            socket.connectToSocket(
                user?.api_token,
                () => {
                    // dispatch(logout())
                },
                () => {
                    dispatch(socketConntected())
                });
        }
        else {
            socket.disconnect()
        }
        return () => socket.disconnect();
    }, [isLoggedIn])

    return <SocketContext.Provider value={socket}>
        {children}
    </SocketContext.Provider>
}